import React from 'react';
import { FiX, FiCheckCircle, FiLoader } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const ImageAnalyzer = ({ 
  imagePreview, 
  isAnalyzing, 
  showDetectionFlash,
  detectionData = null,
  onRemoveImage 
}) => {
  if (!imagePreview) return null;

  const detections = detectionData?.furnitureList || [];
  const hasDetections = detections.length > 0 && !isAnalyzing;

  return (
    <div className="mt-2 relative max-w-md">
      <div className="relative rounded-xl overflow-hidden border-2 border-gray-300 bg-white shadow-lg group">
        <img 
          src={imagePreview} 
          alt="Aperçu" 
          className="w-full h-48 object-cover transition-transform duration-300 group-hover:scale-105"
        />

        {/* Overlay de détections */}
        {hasDetections && detectionData.detectionImage && (
          <div className="absolute inset-0 pointer-events-none">
            <img
              src={`data:image/jpeg;base64,${detectionData.detectionImage}`}
              alt="Détections"
              className="w-full h-full object-cover opacity-85"
            />
          </div>
        )}

        {/* Loader moderne */}
        {isAnalyzing && (
          <div className="absolute inset-0 bg-white/90 backdrop-blur-sm flex items-center justify-center">
            <div className="text-center">
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                className="w-8 h-8 mx-auto mb-2 text-blue-500"
              >
                <FiLoader className="w-full h-full" />
              </motion.div>
              <p className="text-xs font-medium text-gray-700">Analyse...</p>
            </div>
          </div>
        )}

        {/* Badge de détection moderne */}
        {hasDetections && (
          <motion.div
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="absolute top-3 left-3 bg-green-500 text-white px-3 py-1.5 rounded-lg flex items-center gap-2 shadow-lg z-10"
          >
            <FiCheckCircle className="w-4 h-4" />
            <span className="text-xs font-semibold">{detections.length} détecté{detections.length > 1 ? 's' : ''}</span>
          </motion.div>
        )}

        {/* Effet de confirmation simple */}
        <AnimatePresence>
          {showDetectionFlash && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.3 }}
              className="absolute inset-0 bg-green-500/20 flex items-center justify-center"
            >
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.1, type: "spring" }}
                className="bg-white rounded-full p-4 shadow-xl"
              >
                <FiCheckCircle className="w-12 h-12 text-green-500" />
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>

        {/* Bouton de suppression */}
        <button
          onClick={onRemoveImage}
          className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-2 hover:bg-red-600 transition-all shadow-lg hover:scale-110 z-20"
          title="Supprimer l'image"
        >
          <FiX size={16} />
        </button>
      </div>

      {/* Info sur les détections */}
      {hasDetections && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-3 p-3 bg-green-50 rounded-lg border border-green-200"
        >
          <div className="text-sm text-green-800 font-medium flex items-center gap-2">
            <FiCheckCircle className="w-4 h-4" />
            {detections.length} meuble{detections.length > 1 ? 's' : ''} détecté{detections.length > 1 ? 's' : ''} avec succès
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default ImageAnalyzer;




